import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  dontShowTutorialRequest,
  dontShowTutorialSuccess,
  dontShowTutorialFailure,
} from '../reducers/tutorial';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/inTour`;

function* dontShowTutorialFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}/${userId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        userId,
      },
    }),
  );

  return response;
}

function* workerDontShowTutorialSaga() {
  try {
    const response = yield call(dontShowTutorialFunctionAxios);

    const responseFromDontShowTutorial = response.data;
    if (response.status === 200) {
      yield put(dontShowTutorialSuccess(responseFromDontShowTutorial));
    }
  } catch (error) {
    yield put(dontShowTutorialFailure(error.response));
  }
}

export function* watcherDontShowTutorialSaga() {
  yield takeLatest(dontShowTutorialRequest().type, workerDontShowTutorialSaga);
}
